import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setChooseOneRef,
  setRangePairs,
  setRefIndex,
  setRefFromDate,
  setRefToDate,
  setRefToggle,
  setValues,
  setUploadMaskToggle,
  clearRefDates,
  setRefPredFromDate,
  setRefPredToDate,
  setRefPredIndex,
  clearRefPredDates,
} from "../../reducers/PredictionSlice";
import { url } from "../../api/axios_client";
import {
  Autocomplete,
  CircularProgress,
  FormControlLabel,
  Switch,
  TextField,
  Typography,
  Popover,
} from "@mui/material";
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import "./style.css";
import ValuesAndRangesComponent from "./ValuesAndRangesComponent";
import axios from "../../api/axios_client";
import { toast } from "react-toastify";
import OptionsForRangeAndValues from "./OptionsForRangeAndValues";
import { setMaskingFileContent, setUploaderFlag } from "../../reducers/MapSlice";
import parse from "../../utils/file_to_geojson";
import "../../components/styleLTR.css";
import { formatDateDisplay } from "../../utils/date";

const requiredFieldStyle = {
  '& label': {
    '&::after': {
      content: '" *"',
      color: 'red',
    }
  }
};

const RefIndexComponent = ({ indexes, refToggle, showValidation = false }) => {
  const dispatch = useDispatch();
  const RefIndex = useSelector((state) => state.predictionState.RefIndex);
  const chooseOneRef = useSelector((state) => state.predictionState.chooseOneRef);
  const refFromDate = useSelector((state) => state.predictionState.refFromDate);
  const refToDate = useSelector((state) => state.predictionState.refToDate);
  const rangePairs = useSelector((state) => state.predictionState.rangePairs);
  const values = useSelector((state) => state.predictionState.values);
  const uploadMaskToggle = useSelector((state) => state.predictionState.uploadMaskToggle);
  const monthFromRef = useSelector(
    (state) => state.predictionState.refMonthFrom
  );
  const monthToRef = useSelector(
    (state) => state.predictionState.refMonthTo
  );
  const dayFromRef = useSelector(
    (state) => state.predictionState.refDayFrom
  );
  const dayToRef = useSelector(
    (state) => state.predictionState.refDayTo
  );
  const yearFromRef = useSelector(
    (state) => state.predictionState.refYearFrom
  );
  const yearToRef = useSelector(
    (state) => state.predictionState.refYearTo
  );

  useEffect(() => {
    dispatch(setRefPredFromDate(dayFromRef));
    dispatch(setRefPredToDate(dayToRef));
  }, []);

  const monthFrom = useSelector(
    (state) => state.predictionState.selectedMonthFromRefPred
  );
  const monthTo = useSelector(
    (state) => state.predictionState.selectedMonthToRefPred
  );
  const dayFrom = useSelector(
    (state) => state.predictionState.selectedDayFromRefPred
  );
  const dayTo = useSelector(
    (state) => state.predictionState.selectedDayToRefPred
  );
  const yearFrom = useSelector(
    (state) => state.predictionState.selectedYearFromRefPred
  );
  const yearTo = useSelector(
    (state) => state.predictionState.selectedYearToRefPred
  );

  // Add states for prediction mask
  const refPredFromDate = useSelector((state) => state.predictionState.refPredFromDate);
  const refPredToDate = useSelector((state) => state.predictionState.refPredToDate);

  const handleFileChosen = (e) => {
    let file = e.target.files[0];
    if (!file) return;

    const ext = file.name.split(".").pop().toLowerCase();
    if (ext === "tiff" || ext === "tif") {
      dispatch(setMaskingFileContent(file));
      dispatch(setUploaderFlag(true));
    } else {
      parse(
        file,
        ext,
        function onSuccessCB(res) {
          dispatch(setMaskingFileContent(res));
          dispatch(setUploaderFlag(true));
        },
        function onErrorCB() {
          dispatch(setUploaderFlag(false));
          toast.warn("file content isn't valid");
        }
      );
    }
  };

  const handleToggleMask = () => {
    dispatch(setRefToggle());
  };

  const handleUploadMaskToggle = () => {
    dispatch(setUploadMaskToggle());
  };

  const [options, setoptions] = useState();
  const [loading, setloading] = useState(false);

  const filteredIndexes = useMemo(() => {
    if (chooseOneRef) return indexes || [];

    return (indexes || []).filter(index =>
      index.name.toLowerCase().includes('landcover') ||
      index.name.toLowerCase().includes('land cover')
    );
  }, [indexes, chooseOneRef]);

  useEffect(() => {
    const fetchMeta = async () => {
      console.log(JSON.stringify({ index: RefIndex[0] }));
      if (!RefIndex[0]) return;
      try {
        setloading(true);
        const response = await axios.post(`${url}/categories`, {
          id: RefIndex[0],
        });
        console.log("response", response.data);

        // Get flags and nodata from localStorage categories
        let flags = [];
        let nodata = undefined;

        try {
          const categories = JSON.parse(localStorage.getItem('categories')) || [];
          const currentCategory = categories.find(cat => cat.id === RefIndex[0]);
          if (currentCategory) {
            flags = currentCategory.flags || [];
            nodata = currentCategory.nodata;
          }
        } catch (e) {
          console.error("Error getting flags/nodata:", e);
        }

        setoptions({
          ...response.data,
          flags: flags,
          nodata: nodata
        });
      } catch (error) {
        toast.error(error);
      } finally {
        setloading(false);
      }
    };

    fetchMeta();
  }, [RefIndex]);

  // Add state for date picker popovers
  const [historicalPickerAnchorEl, setHistoricalPickerAnchorEl] = useState(null);
  const [predictionPickerAnchorEl, setPredictionPickerAnchorEl] = useState(null);

  // Historical date picker state
  const historicalPickerOpen = Boolean(historicalPickerAnchorEl);
  const historicalPickerId = historicalPickerOpen ? 'historical-daterange-popover' : undefined;

  // Prediction date picker state
  const predictionPickerOpen = Boolean(predictionPickerAnchorEl);
  const predictionPickerId = predictionPickerOpen ? 'prediction-daterange-popover' : undefined;

  // Helper function to validate date strings
  const isValidDate = (dateString) => {
    if (!dateString) return false;
    const date = new Date(dateString);
    return !isNaN(date.getTime());
  };

  // Helper function to get date range from localStorage
  const getDateRange = (indexId) => {
    if (!indexId) return [null, null];
    try {
      const categories = JSON.parse(localStorage.getItem("categories")) || [];
      const currentIndex = categories.find((category) => category.id === indexId);
      if (currentIndex && currentIndex.available_from && currentIndex.available_to) {
        return [new Date(currentIndex.available_from), new Date(currentIndex.available_to)];
      }
    } catch (error) {
      console.error("Error parsing categories from localStorage:", error);
    }
    return [null, null];
  };

  // Helper function to get initial date for picker
  const getInitialDate = (selectedDate, indexId) => {
    if (selectedDate && isValidDate(selectedDate)) {
      return new Date(selectedDate);
    }
    // If no date selected, use the last available date from the index
    const availableRange = getDateRange(indexId);
    if (availableRange[1]) {
      return availableRange[1]; // Return the last available date
    }
    // Fallback to current date if no range available
    return new Date();
  };

  // Date range state for pickers - Initialize with last available date
  const [historicalDateRange, setHistoricalDateRange] = useState([
    {
      startDate: getInitialDate(refFromDate, RefIndex[0]),
      endDate: getInitialDate(refToDate, RefIndex[0]),
      key: 'selection'
    }
  ]);

  const [predictionDateRange, setPredictionDateRange] = useState([
    {
      startDate: getInitialDate(refPredFromDate, RefIndex[0]),
      endDate: getInitialDate(refPredToDate, RefIndex[0]),
      key: 'selection'
    }
  ]);

  // Update date range state when Redux state changes OR when RefIndex changes
  useEffect(() => {
    if (refFromDate && refToDate && isValidDate(refFromDate) && isValidDate(refToDate)) {
      setHistoricalDateRange([{
        startDate: new Date(refFromDate),
        endDate: new Date(refToDate),
        key: 'selection'
      }]);
    } else if (RefIndex[0]) {
      // If no dates selected but index is selected, use last available date
      const availableRange = getDateRange(RefIndex[0]);
      if (availableRange[1]) {
        setHistoricalDateRange([{
          startDate: availableRange[1],
          endDate: availableRange[1],
          key: 'selection'
        }]);
      }
    }

    if (refPredFromDate && refPredToDate && isValidDate(refPredFromDate) && isValidDate(refPredToDate)) {
      setPredictionDateRange([{
        startDate: new Date(refPredFromDate),
        endDate: new Date(refPredToDate),
        key: 'selection'
      }]);
    } else if (RefIndex[0]) {
      // If no dates selected but index is selected, use last available date
      const availableRange = getDateRange(RefIndex[0]);
      if (availableRange[1]) {
        setPredictionDateRange([{
          startDate: availableRange[1],
          endDate: availableRange[1],
          key: 'selection'
        }]);
      }
    }
  }, [refFromDate, refToDate, refPredFromDate, refPredToDate, RefIndex]);

  // Handle date picker clicks
  const handleHistoricalPickerClick = (event) => {
    if (!RefIndex[0] && !uploadMaskToggle) {
      toast.warning("Please select a mask index first");
      return;
    }
    setHistoricalPickerAnchorEl(event.currentTarget);
  };

  const handleHistoricalPickerClose = () => {
    setHistoricalPickerAnchorEl(null);
  };

  const handlePredictionPickerClick = (event) => {
    if (!RefIndex[0] && !uploadMaskToggle) {
      toast.warning("Please select a mask index first");
      return;
    }
    setPredictionPickerAnchorEl(event.currentTarget);
  };

  const handlePredictionPickerClose = () => {
    setPredictionPickerAnchorEl(null);
  };

  // Handle date range changes
  const handleHistoricalRangeChange = (item) => {
    if (!item || !item.selection || !item.selection.startDate || !item.selection.endDate) {
      return;
    }

    setHistoricalDateRange([item.selection]);
    const fromDate = new Date(item.selection.startDate);
    const toDate = new Date(item.selection.endDate);

    if (isNaN(fromDate.getTime()) || isNaN(toDate.getTime())) {
      return;
    }

    fromDate.setHours(12, 0, 0, 0);
    toDate.setHours(12, 0, 0, 0);
    dispatch(setRefFromDate(fromDate.toISOString().split("T")[0]));
    dispatch(setRefToDate(toDate.toISOString().split("T")[0]));
  };

  const handlePredictionRangeChange = (item) => {
    if (!item || !item.selection || !item.selection.startDate || !item.selection.endDate) {
      return;
    }

    setPredictionDateRange([item.selection]);
    const fromDate = new Date(item.selection.startDate);
    const toDate = new Date(item.selection.endDate);

    if (isNaN(fromDate.getTime()) || isNaN(toDate.getTime())) {
      return;
    }

    fromDate.setHours(12, 0, 0, 0);
    toDate.setHours(12, 0, 0, 0);
    dispatch(setRefPredFromDate(fromDate.toISOString().split("T")[0]));
    dispatch(setRefPredToDate(toDate.toISOString().split("T")[0]));
  };

  // Format date for display
  const formatDateRange = (fromDate, toDate) => {
    if (!fromDate || !toDate || !isValidDate(fromDate) || !isValidDate(toDate)) {
      return "Select Date Range";
    }
    const start = formatDateDisplay(new Date(fromDate));
    const end = formatDateDisplay(new Date(toDate));
    return start === end ? start : `${start} - ${end}`;
  };

  // Get available date range for display
  const getAvailableDateRangeText = (indexId) => {
    const [minDate, maxDate] = getDateRange(indexId);
    if (!minDate || !maxDate) return "";
    return `Available: ${formatDateDisplay(minDate)} - ${formatDateDisplay(maxDate)}`;
  };

  // Check if field should show error
  const shouldShowError = (isValid) => {
    return showValidation && refToggle && !isValid;
  };

  // Validation checks
  const hasRefIndex = RefIndex[0] || uploadMaskToggle;
  const hasHistoricalDateRange = refFromDate && refToDate && isValidDate(refFromDate) && isValidDate(refToDate);
  const hasPredictionDateRange = refPredFromDate && refPredToDate && isValidDate(refPredFromDate) && isValidDate(refPredToDate);

  // Validation logic:
  // - Ref index is valid if: uploading mask OR has selected index
  const isRefIndexValid = uploadMaskToggle || RefIndex[0];

  // - Historical date range is valid if: uploading mask OR has date range
  const isHistoricalDateRangeValid = uploadMaskToggle || hasHistoricalDateRange;

  // - Prediction date range is valid if: single mask mode OR uploading mask OR has date range
  const isPredictionDateRangeValid = chooseOneRef || uploadMaskToggle || hasPredictionDateRange;

  return (
    <div className="pred-ref-inner-container">
      <Typography fontSize={24} fontWeight={600} fontFamily={"monospace"}>
        Masking Index (optional)
      </Typography>

      <div>
        <FormControlLabel
          control={
            <Switch
              checked={refToggle}
              onChange={() => handleToggleMask()}
              color="primary"
            />
          }
          label="Do you want to use Masking ?"
        />
      </div>
      {refToggle && (
        <>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ flex: 1, padding: "10px" }}>
              <div style={{ width: "100%" }}>
                <FormControlLabel
                  sx={{ marginBottom: "1em" }}
                  control={
                    <Switch
                      checked={chooseOneRef}
                      onChange={() => dispatch(setChooseOneRef())}
                      color="primary"
                    />
                  }
                  label="Choose One Mask"
                />
              </div>
              {/* Historical Mask Section - Always visible */}
              <div style={{ marginBottom: "1em" }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={uploadMaskToggle}
                      onChange={() => handleUploadMaskToggle()}
                      color="primary"
                      disabled={!chooseOneRef} // Disable when not in single mask mode
                    />
                  }
                  label="Upload Mask"
                />
              </div>
              <Typography fontWeight={500}>{"Mask Index"}</Typography>

              <>
                {chooseOneRef && uploadMaskToggle ? (
                  <div className="mask-upload-container">
                    <input
                      style={{ fontSize: "10px" }}
                      type="file"
                      onChange={handleFileChosen}
                      accept=".tiff,.tif"
                      id="file"
                      placeholder=""
                      disabled={false}
                    />
                  </div>
                ) : (
                  <div>
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="historical-mask"
                      isOptionEqualToValue={(option, value) => option.name === value.name}
                      getOptionLabel={(option) => (option ? option.name : "")}
                      onChange={(event, selected) => {
                        if (selected) {
                          console.log("selected", selected);
                          dispatch(setRefIndex([selected.id]));
                        }
                      }}
                      options={filteredIndexes || []}
                      sx={{ width: "100%" }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={chooseOneRef ? "Select Mask" : "Mask Index"}
                          required
                          error={shouldShowError(isRefIndexValid)}
                          helperText={shouldShowError(isRefIndexValid) ? "This field is required" : ""}
                        />
                      )}
                    />
                    <br />
                    <div style={{ width: "100%" }}>
                      <Typography>{!chooseOneRef ? "Select Historical Range *" : "Select Range *"}</Typography>
                      {RefIndex[0] && (
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', marginBottom: '8px' }}>
                          {getAvailableDateRangeText(RefIndex[0])}
                        </Typography>
                      )}
                      <TextField
                        label="Selected Date Range"
                        variant="outlined"
                        fullWidth
                        size="small"
                        margin="normal"
                        required
                        error={shouldShowError(isHistoricalDateRangeValid)}
                        helperText={shouldShowError(isHistoricalDateRangeValid) ? "This field is required" : ""}
                        sx={requiredFieldStyle}
                        aria-describedby={historicalPickerId}
                        value={formatDateRange(refFromDate, refToDate)}
                        onClick={handleHistoricalPickerClick}
                        disabled={!RefIndex[0] && !uploadMaskToggle}
                        InputProps={{
                          readOnly: true, // Make field read-only
                        }}
                      />
                      {!RefIndex[0] && !uploadMaskToggle && (
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', marginTop: '-8px' }}>
                          Please select a mask index first to enable date selection.
                        </Typography>
                      )}
                      <Popover
                        id={historicalPickerId}
                        open={historicalPickerOpen}
                        anchorEl={historicalPickerAnchorEl}
                        onClose={handleHistoricalPickerClose}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'left',
                        }}
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'left',
                        }}
                      >
                        <DateRangePicker
                          staticRanges={[]} // Hide predefined ranges sidebar
                          ranges={historicalDateRange}
                          onChange={handleHistoricalRangeChange}
                          minDate={getDateRange(RefIndex[0])[0]} // Use minDate from getDateRange
                          maxDate={getDateRange(RefIndex[0])[1]} // Use maxDate from getDateRange
                          showSelectionPreview={true}
                          moveRangeOnFirstSelection={false}
                          months={1} // Show one month
                          direction="horizontal"
                          editableDateInputs={false} // Hide manual input fields
                        />
                      </Popover>
                    </div>
                  </div>
                )}
              </>

              {/* Prediction Mask Section - Visible when not using single mask and not upload */}
              <br />
              <>
                {!uploadMaskToggle && !chooseOneRef && (
                  <div style={{ width: "100%" }}>
                    <Typography>Select Current Range *</Typography>
                    {RefIndex[0] && (
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', marginBottom: '8px' }}>
                        {getAvailableDateRangeText(RefIndex[0])}
                      </Typography>
                    )}
                    <TextField
                      label="Selected Date Range"
                      variant="outlined"
                      fullWidth
                      size="small"
                      margin="normal"
                      required
                      error={shouldShowError(isPredictionDateRangeValid)}
                      helperText={shouldShowError(isPredictionDateRangeValid) ? "This field is required" : ""}
                      sx={requiredFieldStyle}
                      aria-describedby={predictionPickerId}
                      value={formatDateRange(refPredFromDate, refPredToDate)}
                      onClick={handlePredictionPickerClick}
                      disabled={!RefIndex[0]}
                      InputProps={{
                        readOnly: true, // Make field read-only
                      }}
                    />
                    {!RefIndex[0] && (
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', marginTop: '-8px' }}>
                        Please select a mask index first to enable date selection.
                      </Typography>
                    )}
                    <Popover
                      id={predictionPickerId}
                      open={predictionPickerOpen}
                      anchorEl={predictionPickerAnchorEl}
                      onClose={handlePredictionPickerClose}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                    >
                      <DateRangePicker
                        staticRanges={[]} // Hide predefined ranges sidebar
                        ranges={predictionDateRange}
                        onChange={handlePredictionRangeChange}
                        minDate={getDateRange(RefIndex[0])[0]} // Use minDate from getDateRange
                        maxDate={getDateRange(RefIndex[0])[1]} // Use maxDate from getDateRange
                        showSelectionPreview={true}
                        moveRangeOnFirstSelection={false}
                        months={1} // Show one month
                        direction="horizontal"
                        editableDateInputs={false} // Hide manual input fields
                      />
                    </Popover>
                  </div>
                )}
              </>

              <br />
              <ValuesAndRangesComponent
                rangePairs={rangePairs}
                setRangePairs={setRangePairs}
                setValues={setValues}
                values={values}
                options={options}
              />
            </div>

            <div style={{ flex: 1, padding: "20px" }}>
              {loading ? (
                <CircularProgress />
              ) : (
                options && (
                  <div>
                    <Typography fontWeight={500}>{options.unit ?? ""}</Typography>
                    <OptionsForRangeAndValues data={options} />
                  </div>
                )
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default RefIndexComponent;